/**
* @Author: 858834013@qq.com
* @Name: 实时信息
* @Date: 2022-08-16
* @Desc:实时信息
*/
<template>
  <div>
    <div @click="getShow" class="cur">
      <slot></slot>
    </div>
    <TinyLayer
      v-model="layerVisible"
      :header-visible="false"
      :footer-visible="false"
      class-name="newPopWin"
      :body-scrollable="false"
      width="520"
      :z-index=100
      content-background="rgba(0,0,0,0)"
      background="rgba(0,0,0,0)"
      mask-background="rgba(0, 22, 120, 0.9)"
      mask-closable
    >
      <div class="popWin">
        <div class="popWinBody">
          <div class="close" @click="getHide">
            <img src="../../../assets/home/icon_close2.png" alt="">
          </div>
          <titleInfo title="报警记录"></titleInfo>
          <div class="popWinMain">
            <div class="popWinMainRight">
              <img src="../../../assets/home/icon_gaojing.png" alt="">
            </div>
            <div class="popWinMainLeft">
              <p><em>报警类型:</em> <span>严重短路</span></p>
              <p><em><b>时</b><b>间:</b></em><span>2021-07-21 14:45:00</span></p>
              <p><em><b>地</b><b>点:</b></em><span>中国科技大学1411教室</span></p>
              <p><em>责任人: </em><span>张三</span></p>
            </div>
          </div>
          <div class="line">
            <img src="../../../assets/home/icon_line4.png" alt="">
          </div>
          <div class="disposal">
            <div class="disposalTitle">
              处置:
            </div>
            <div class="disposalForm">
              <div class="disposalFormItem">
                <div class="label">处置时间：</div>
                <el-date-picker
                  v-model="value1"
                  type="datetime"
                  placeholder="选择日期时间">
                </el-date-picker>
              </div>
              <div class="disposalFormItem">
                <div class="label">处 置 人 ：</div>
                <input type="text">
              </div>
              <div class="disposalFormItem">
                <div class="label">处置措施：</div>
                <textarea name="" id="" cols="30" rows="10"></textarea>
              </div>
            </div>
          </div>
          <div class="operation">
            <div class="cancel">确 定</div>
            <div class="confirm" @click="getHide">关 闭</div>
          </div>
        </div>
      </div>
    </TinyLayer>
  </div>
</template>

<script>
import TinyLayer from "tinylayer";
import titleInfo from "@/components/titleInfo";

export default {
  name: "message",
  components: {TinyLayer, titleInfo},
  props: {
    id: {
      type: String,
      default() {
        return '';
      }
    }
  },
  data() {
    return {
      newIpAddress: '',
      layerVisible: false,
      value1: ''
    }
  },
  watch: {},
  mounted() {
  },
  methods: {
    getShow() {
      this.layerVisible = true
    },
    getHide() {
      this.layerVisible = false
    }
  }
}
</script>

<style lang="scss" scoped>
.popWin {
  width: 518px;
  height: 603px;
  background: url("../../../assets/home/item6_popbg1.png") no-repeat;
  background-size: 100% 100%;
}

.operation {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: nowrap;
  flex-direction: row;
  align-content: flex-start;
  margin-top: 10px;

  .cancel {
    width: 120px;
    height: 38px;
    background: #FFFFFF;
    background: url("../../../assets/home/item_but1.png") no-repeat;
    background-size: 100% 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: nowrap;
    flex-direction: row;
    align-content: flex-start;
    font-size: 18px;
    font-family: PingFang;
    cursor: pointer;
    font-weight: 500;
    color: #FFFFFF;
    margin-right: 70px;
  }

  .confirm {
    width: 120px;
    height: 38px;
    margin-left: 70px;
    background: #FFFFFF;
    background: url("../../../assets/home/item_but1.png") no-repeat;
    display: flex;
    justify-content: center;
    background-size: 100% 100%;
    align-items: center;
    flex-wrap: nowrap;
    flex-direction: row;
    align-content: flex-start;
    font-size: 18px;
    font-family: PingFang;
    font-weight: 500;
    color: #FFFFFF;
    cursor: pointer;
  }

  .cancel:hover, .confirm:hover {
    opacity: 0.7;
  }

  .line {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: nowrap;
    flex-direction: row;
    align-content: flex-start;

    img {
      width: 456px;
      height: 1px;
    }
  }
}

.popWinMain {
  margin-top: 20px;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-wrap: nowrap;
  flex-direction: row;
  align-content: flex-start;

  .popWinMainLeft {
    p {
      font-size: 14px;
      font-family: PingFang;
      font-weight: 500;
      color: rgba(#01A3FF, 0.6);
      display: flex;
      justify-content: flex-start;
      align-items: center;
      flex-wrap: wrap;
      flex-direction: row;
      align-content: flex-start;
      height: 40px;

      em {
        font-style: normal;
        margin-right: 10px;
        width: 60px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex-wrap: nowrap;
        flex-direction: row;
        align-content: flex-start;
      }

      span {
        font-size: 14px;
        font-family: PingFang;
        font-weight: 500;
        color: #CDF7FF;
      }

      .status {
        font-size: 16px;
        font-family: PingFang;
        font-weight: 500;
        color: #99DCFE;
        width: 54px;
        height: 26px;
        background: rgba(70, 188, 255, 0.3);
        border: 1px solid #46BCFF;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-wrap: nowrap;
        flex-direction: row;
        align-content: flex-start;
      }

      .status2 {
        color: rgba(255, 215, 74, 1);
      }
    }
  }

  .popWinMainRight {
    display: flex;
    width: 199px;
    justify-content: center;
    align-items: center;
    flex-wrap: nowrap;
    flex-direction: column;
    align-content: flex-start;

    img {
      width: 163px;
    }

    p {
      font-size: 20px;
      font-family: PingFang;
      font-weight: 500;
      margin-top: 14px;
      color: #56E400;
    }
  }
}

.popWinBody {
  margin-left: 20px;
  padding-top: 10px;
}

.close {
  position: absolute;
  right: 15px;
  top: 15px;
  cursor: pointer;

  img {
    width: 20px;
    height: 20px;
  }
}

.disposal {
  margin-left: 30px;

  .disposalTitle {
    font-size: 18px;
    font-family: PingFang;
    font-weight: bold;
    color: #34DCFC;
    margin-top: 25px;
    margin-bottom: 25px;
  }

  .disposalForm {

    .disposalFormItem {
      display: flex;
      justify-content: flex-start;
      align-items: flex-start;
      flex-wrap: nowrap;
      flex-direction: row;
      align-content: flex-start;
      margin-bottom: 20px;

      .label {
        font-size: 16px;
        font-family: PingFang;
        font-weight: 500;
        color: #01A3FF;
        line-height: 24px;
        opacity: 0.6;
      }

      ::v-deep {
        .el-input__inner {
          width: 241px;
          height: 28px;
          background: rgba(0, 168, 255, 0.3);
          border: 1px solid rgba(#00A8FF, 0.5);
          font-size: 16px;
          font-family: PingFang;
          font-weight: 500;
          color: #CDF7FF;
          outline: none;
          padding-left: 10px;
          padding-right: 10px;
        }

        .el-input__prefix, .el-input__suffix {
          height: 28px;
          display: none;
        }

        /* 下面设置右侧按钮居中 */
        .el-input__suffix {
          top: 0px;
          display: flex;
          justify-content: center;
          align-items: center;
          flex-wrap: nowrap;
          flex-direction: row;
          align-content: flex-start;
        }

        .el-input__icon {
          line-height: 28px;
        }
      }

      input {
        width: 241px;
        height: 28px;
        background: rgba(0, 168, 255, 0.3);
        border: 1px solid rgba(#00A8FF, 0.5);
        font-size: 16px;
        font-family: PingFang;
        font-weight: 500;
        color: #CDF7FF;
        outline: none;
        padding: 10px;
      }

      textarea {
        width: 241px;
        height: 88px;
        background: rgba(0, 168, 255, 0.3);
        border: 1px solid rgba(#00A8FF, 0.5);
        font-size: 16px;
        font-family: PingFang;
        font-weight: 500;
        outline: none;
        color: #CDF7FF;
        padding: 10px;
      }
    }
  }
}
</style>
